/**
 * PloneBackendView component
 * Muestra página 404 para vistas especiales de Plone (@@...)
 * Las peticiones API al backend siguen funcionando normalmente
 */

import React from 'react';
import { NotFound } from '@plone/volto/components';

const PloneBackendView = () => {
  return <NotFound />;
};

export default PloneBackendView;
